<template>
    <sa-page-layout :btnBackVisible="false" :btnEditVisible="btnEditVisible" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template #toolbar>
            <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Csv</b-button>
        </template>
        <template slot="table-body">
            <rsa-scheda-ospite-referti-component ref="cmpRsaSchedaOspiteReferti"></rsa-scheda-ospite-referti-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaSchedaOspiteRefertiComponent from "../components/RsaSchedaOspiteRefertiComponent.vue";
export default {
    components: { SaPageLayout, RsaSchedaOspiteRefertiComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            btnEditVisible: false,
            showModalLoading: false,
            linkback: null,
            linkedit: null,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteReferti.loadData();
        },
        onScaricaCsv() {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteReferti.scaricaCsv();
        },
    },
};
</script>
<style></style>
